import React from 'react';
import styled from 'react-emotion';
import ReactDisqusComments from 'react-disqus-comments';
import Container from './Container';

const StyledContainer = styled(Container)`
  max-width: 55rem;
  margin-bottom: 4rem;
  padding-left: 2rem;
  padding-right: 2rem;
`;

const DisqusContainer = ({ children }) => <StyledContainer>{children}</StyledContainer>;

export default DisqusContainer;



// WEBPACK FOOTER //
// ./src/components/DisqusContainer.jsx